import { createContext, useEffect } from 'react';

const Context = createContext({});

export { Context };
